<template>
  <div class="header">
    <div class="titleLh lf">
      <span>{{systemTitle}} </span>
      <b>|</b>
      {{ title2 }}
    </div>
    <p class='lf' style="margin-left:100px">
      国家授时中心时间:<span class='time'>{{time}}</span><span class='date'>{{date}}</span>
    </p>
    <div class='rt'>
      <div v-if="isShow" class="bidInquiry" @click="openList">
        <img src="@/assets/images/msg.png" alt="">
        <span>询标回复</span>
        <b class="xbsl">{{ num }}</b>
      </div>
      <div class="changeRole" v-if='role'>
        <template v-if='Object.keys(roles).length>=2'>
          <p class='show' @click='showRoles=!showRoles'>{{role}}</p>
          <ul v-show='showRoles'>
            <li @click='changeRole(key)' v-for='(key,value) in roles' :key='key'>{{value}}</li>
          </ul>
        </template>
        <template v-else>
          <p>{{role}}</p>
        </template>
      </div>
      <span v-if='user && !isLogin'>{{user}}</span>
      <button v-if='user && !isLogin' type='button' @click='loginOut'>退出</button>
      <span v-else class="rightTitle">
        <a href="https://lxjypt.zhaotx.cn/" target="_blank">交易平台</a> |
        <a @click="showCA">CA锁驱动</a>
      </span>
    </div>
  </div>
</template>

<script>
import setting  from "@/settings"
import {title,systemTitle,title2} from "@/settings"
export default {
  name: 'myheader',
  props: [ 'num', 'isShow' ],
  data(){
    return{
      interval:null,
      showRoles:false,
      roles:{},
      role:"",

      // websocket
      path: (location.protocol === 'http:' ? 'ws' : 'wss') + '://'+window.location.host+'/api/v1/websocket/pb_inquiry',
      timeoutobj: null,
      serverTimeout: null,
      lockReconnect: false,

      timestamp: 0
    }
  },
  computed:{
    user(){
      return localStorage.getItem('user')?localStorage.getItem('user'):''
    },
    title(){
      return title
    },
    title2(){
      return title2
    },
    systemTitle(){
      return systemTitle
    },
    date() {
      return this.timestamp ? this.$moment(this.timestamp).format("YYYY-MM-DD") : '';
    },
    time() {
      return this.timestamp ? this.$moment(this.timestamp).format("HH:mm:ss") : '';
    },
    isLogin() {
      return this.$route.path == '/login'
    }
  },
  methods:{
    openList() {
      this.$emit('openList')
    },
    getGjTime(){
      let para = {}
      clearInterval(this.interval)
      this.interval=null;
      this.$api.getGjsssj(para).then(res=>{
        if(res.data.meta.success){
          this.timestamp = +new Date(this.$moment(res.data.data.gjsssj).format("YYYY/MM/DD HH:mm:ss"));
          this.timeout()
        }
      }).catch(()=>{})
    },

    timeout() {
      this.interval = setTimeout(() => {
        clearTimeout(this.interval);
        this.interval = null;
        this.timestamp += 1000;
        this.timeout();
      },1000)
    },

    loginOut(){
      this.$router.push('/logout')
    },
    checkViChange(){
      if(!document.hidden){
        //如果浏览器处于禁止状态，则重新获取数据
        this.getGjTime();
      }
    },
    //切换角色
    changeRole(id){
      this.showRoles=false;
      localStorage.setItem('role',id)
      if(this.$route.name=="kbxmList"){
        this.$router.go(0)
      }else{
        this.$router.push('/kbxmList');
        localStorage.removeItem('lcSteps');
        localStorage.removeItem('xmmc');
        localStorage.removeItem('bdId');
        localStorage.removeItem('kbxmZt')
      }
    },
    getRoles(){
      let para={
        username:this.user
      }
      this.$api.changeRyjs(para).then(res=>{
        if(res.data.meta.success){
          this.roles=res.data.data;
          for (const key in this.roles) {
            if (this.roles.hasOwnProperty.call(this.roles, key)) {
              const value = this.roles[key];
              if(localStorage.getItem('role')==value)this.role=key
            }
          }
        }else{
          this.$message({
              message: res.data.meta.message,
              type: 'error'
          });
        }
      }).catch(()=>{})
    },
    showCA(){
      window.location.href = 'https://jypt.zhaotx.cn/static/tools/zjcahrqd.exe';
    },

    longStart(){
        console.log('longStart')

        clearInterval(this.timeoutobj);
        clearTimeout(this.serverTimeout);
        this.timeoutobj = null;
        this.serverTimeout = null;
        this.lockReconnect = false;

        console.log('longStart - test')
        this.timeoutobj = setInterval(() => {
            var data = { type: 999 }
            console.log('this.websocket', this.websocket);
            console.log('this.websocket.readyState', this.websocket?.readyState);
            if(this.websocket?.readyState === 1) {
              this.websocket.send(JSON.stringify(data))
            }
            this.serverTimeout = setTimeout(() => {
              this.lockReconnect = true
              this.websocket.close()
            }, 2000)
        },10000)
    },
    initWebSocket() {
      // 机构代码非空校验
      if (!localStorage.getItem('jgdm')) return
      // 投标人（B）角色校验
      if(localStorage.getItem('role') != 'B') return
      if (typeof WebSocket === "undefined") {
        console.error("浏览器不支持 WebSocket ");
        return
      }

      this.websocket = new WebSocket(this.path);
      this.websocket.onopen = this.websockOpen; // 监听打开
      this.websocket.onclose = this.websockClose; // 监听关闭
      this.websocket.onerror = this.websockError; // 监听异常
      this.websocket.onmessage = this.websockMessage; // 监听消息
    },
    websockOpen(e) {
      console.log("websocket 连接成功", e);
      this.longStart(); // 开启心跳检测
    },
    websockClose(e) {
      console.log("websocket 连接关闭", e);
      if(this.lockReconnect){
        // this.initWebSocket()
      }
    },
    websockError(e) {
      console.log("websocket 连接出错", e, e.target?.url);
      // this.initWebSocket()
    },
    websockMessage(e) {
      console.log("websocket 收到消息", e, e.data);
      const data = JSON.parse(e.data)
      const type = data.type
      if(type == 1){
        //专家询标
        const jgdm= localStorage.getItem('jgdm')
        if (!jgdm) return
        const orgCodes = data.orgCodes;
        if(orgCodes.includes(jgdm)){
          console.log('有专家对我发起询标')
          this.openList()
        }
      }
    },
    againTime() {
      var bowhidden="hidden" in document?"hidden": "webkithidden" in document?"webkithidden": "mozhidden" in document ?"mozhidden": null;
      var vibchage="visibilitychange" || "webkitvisibilitychange" || "mozvisibilitychange";
      document.addEventListener(vibchage,()=> {
        if(!document[bowhidden]) /*false*/
        {
          this.getGjTime()
        }
      });
    }
  },
  mounted(){
    if(this.user){
      this.getRoles();
    }
    this.getGjTime();
    let _this=this;
    document.addEventListener("visibilitychange", _this.checkViChange);
    this.againTime()
    // this.initWebSocket() // 初始化 websocket
  },
  destroyed(){
    document.removeEventListener("visibilitychange",this.checkViChange)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.header{
  padding:0 30px;
  height:80px;
  line-height: 80px;
  background:@base-color;
  color:#fff;
  font-size: 16px;
  overflow: visible;
  .role{
    font-weight: bold;
    color:#ffff00;
  }
  p{
    height:80px;
  }
  .xtName{
    font-size: 26px;
    font-weight: bold;
    background: url("../assets/images/logo_w.png") no-repeat center left;
    padding-left:55px
  }
  .bigName{
    font-size: 28px;
    font-weight: bold;
  }
  .changeRole{
    display:inline-block;
    margin-right:10px;
    position: relative;
    background: rgba(255, 255, 255, 0.15);
    line-height: 25px;
    height: 32px;
    padding: 3px;
    border-radius: 3px;
    p.show{
      height: 25px;
      background:url('../assets/images/down2.png') no-repeat center right;
      background-size: 20px;
      padding: 0 20px 0 5px;
      cursor: pointer;
    }
    ul{
      box-sizing:content-box;
      position: absolute;
      top:55px;
      left:-30px;
      background: #fff;
      padding:10px 0;
      border-radius: 3px;
      min-width: 110px;
      z-index: 99;
      li{
        color:#666;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
      }
    }
  }
  // .changeRole:before{
  //   content:'';
  //   display:block;
  //   height:20px;
  //   border-left:1px solid #fff;
  //   position: absolute;
  //   top:30px;
  //   left:-10px;
  // }
  .time{
    font-size: 28px;
    font-weight: bold;
    margin: 0 15px 0 10px;
  }
  .date{
    font-weight: bold;
  }
  button{
    // border:1px solid #fff;
    min-width:20px;
    height:38px;
    line-height:38px;
    color:#fff;
    border-radius:3px;
    background:transparent;
    font-size: 16px;
    margin-left:20px;
  }
  a{
    text-decoration: none;
    color:#fff;
  }
}
.bidInquiry{
  display: inline-block;
  cursor: pointer;
  .xbsl{
    font-size: 12px;
    background-color: red;
    border-radius: 10px;
    padding: 0 1px;
    position: relative;
    top: 0px;
    left: -55px;
  }
  img{
    width: 25px;
    height: 25px;
  }
  span{
    font-size: 12px;
    position: relative;
    top: 15px;
    right: 36px;
  }
}
.rightTitle{
  display: inline-block;
  justify-self: right;
  font-size: 14px;
  font-weight: normal;
  margin-top: 5px;
}
.titleLh {
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFF;
  display: inline;
  height: 100%;
  span{
    font-size: 32px;
  }
  b{
    font-weight: 100;
  }
}
</style>
